import get from 'lodash/get';

function validateGradeEffectNodess(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];
  const gradeEffectNodes = nodeInfo.effectNodes.filter(
    (node) => get(node, 'data.effect.type') === 'GRADING',
  );
  if (gradeEffectNodes.length) {
    gradeEffectNodes.forEach(effectNode => {
      const result = hasActionOrInitialTimerNode(effectNode, nodeInfo.nodeMap);
      if (!result.hasMatching) {
        errors.push({
          message: 'Grading effect must have action or initial timer in input chain',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: effectNode.id,
          metadata: {
            nodeId: effectNode.id,
          },
        });
      }
      if (!effectNode.data.effect.label) {
        errors.push({
          message: 'Grading effect must have name',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: effectNode.id,
          metadata: {
            nodeId: effectNode.id,
          },
        });
      }
    });
  }
  return {
    errors,
    warnings,
  };
}

function hasActionOrInitialTimerNode(node, nodeMap, cumul = { path: [], hasMatching: false }) {
  const inputConnections = get(node, 'inputs.inputs.connections', []);
  if (inputConnections.length === 0) {
    const isActionOrTimer = node.name === 'Action' || node.name === 'Timer';
    return {
      hasMatching: cumul.hasMatching || isActionOrTimer,
      path: cumul.path.concat(node.id)
    };
  }

  let hasMatching = cumul.hasMatching;
  let path = cumul.path;
  inputConnections.forEach(connection => {
    const inputNode = nodeMap[connection.node];
    // Prevent case logic loops from only traversing nodes that haven't been seen yet
    if (inputNode && !cumul.path.includes(inputNode.id)) {
      const result = hasActionOrInitialTimerNode(inputNode, nodeMap, {
        hasMatching: cumul.hasMatching,
        path: cumul.path.concat(node.id)
      });
      hasMatching = hasMatching || result.hasMatching;
      path = path.concat(result.path);
    }
  });

  return {
    hasMatching,
    path
  };
}

export default validateGradeEffectNodess;